import * as React from "react";
import { cn } from "@/lib/utils";

export interface LabelProps extends React.ComponentProps<"label"> {
  required?: boolean;
  labelSuffix?: React.ReactNode;
}

function Label({
  className,
  children,
  required,
  labelSuffix,
  ...props
}: LabelProps) {
  return (
    <label
      data-slot="label"
      className={cn(
        "text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5 inline-block select-none",
        className
      )}
      {...props}
    >
      {children}
      {required ? <span className="text-red-500 ml-1 font-bold">*</span> : null}
      {labelSuffix}
    </label>
  );
}

export { Label };
export default Label;
